import React, { type FC } from "react";

import type { HealthStateValue } from "~/models/dto";
import { type VariantProps, cv } from "~/tools/class-variance";

import type { Api } from "../../../common/openapi";
import { HealthStateCircle } from "../HealthCircle/HealthStateCircle";

const variants = cv("flex items-center gap-2", {
	variants: {
		layout: {
			"indicator-ratio": null,
			"ratio-indicator": "flex-row-reverse",
		},
	},

	defaultVariants: {
		layout: "indicator-ratio",
	},
});

export interface ReadyStatusDisplayProps extends VariantProps<typeof variants> {
	readyStatus: HealthStateValue | Api.HealthStateValue | undefined;
	ready: number;
	total: number;
}

export const ReadyStatusDisplay: FC<ReadyStatusDisplayProps> = ({ readyStatus, ready, total, layout }) => (
	<div className={variants({ layout, className: null })}>
		{readyStatus && <HealthStateCircle size="small" state={readyStatus} />}
		<span>
			{ready} / {total}
		</span>
	</div>
);
